var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"tebs-item",class:{ active: index == _vm.cunnerIndex },on:{"click":function($event){return _vm.clickTabs(index)}}},[_c('i',{staticClass:"iconfont",class:[item.icon]}),_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }